import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, OnDestroy, Input } from '@angular/core';
import { CoreLogService } from '../../services/log.service';
import { CoreLanguageService } from '../../services/language.service';
import { WebShopService } from '../../services/webShop.service';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { RemoteGroupOrderService } from '../../services/RemoteGroupOrder.service';
import { IGroupManageData } from '../../services/IRemoteGroupOrderService';

@Component({
  selector: 'ya-remoteGroupHomeButton',
  templateUrl: './remoteGroupHomeButton.component.html',
  styleUrls: ['./remoteGroupHomeButton.component.scss'],
})
export class RemoteGroupHomeButtonComponent implements OnInit, OnDestroy {
  @ViewChild('container') container: ElementRef;
  @ViewChild('infocontainer') infocontainer: ElementRef;
  @Input() public displaySummary: boolean = false;

  private _itemsChangedSubscription: Subscription;

  public expanded: boolean = true;
  public groupManageData: IGroupManageData;
  public itemsCount$: Observable<number>;
  public totalPrice$: Observable<number>;
  public endTimeInfoLabel: string = "";

  constructor(private _remoteGroupOrderService: RemoteGroupOrderService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _webShopService: WebShopService
    , private _router: Router
  ) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RemoteGroupHomeButtonComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me._itemsChangedSubscription = me._remoteGroupOrderService.itemsChanged$.subscribe(() => {
      me._remoteGroupOrderService.loadBasketData();
    });
    me.groupManageData = me._remoteGroupOrderService.groupManageData;
    me.itemsCount$ = me._remoteGroupOrderService.groupBasketItemsCount$;
    me.totalPrice$ = me._remoteGroupOrderService.groupBasketTotalPrice$;
    me.endTimeInfoLabel = me.setGroupOrderEndTime();
    me.PushChanges();
  }

  ngOnDestroy() {
    const me = this;
    if (me._itemsChangedSubscription) {
      me._itemsChangedSubscription.unsubscribe();
    }
  }

  /** set label for order end time */
  private setGroupOrderEndTime() {
    const me = this;
    const value = this.groupManageData.selectedOrderTime;
    const day = me._remoteGroupOrderService.dayDisplayValue(value);
    const time = me._remoteGroupOrderService.timeDisplayValue(value);
    const isdayToday = me._remoteGroupOrderService.isDayToday(value);
    if (isdayToday) {
      return me._coreLanguageService.value("phRemoteOrder_Group_End_Time_Today")
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    } else {
      return me._coreLanguageService.value("phRemoteOrder_Group_End_Time")
        .replace("{day}", `<span class="emphasized">${day}</span>`)
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    }
  }

  /** Information about items */
  public setBasketItemsInfo(items: number) {
    const me = this;
    return me._coreLanguageService.value("phRemoteOrder_Home_Button_Items")
      .replace("{items_count}", `<span class="emphasized">${items}</span>`);
  }

  /**
 * Toggles the expansion state of the container.
 * Adjusts the container's position based on its expanded state.
 */
  public toggleExpand(): void {
    const me = this;
    me.expanded = !me.expanded;
    const rightPosition = me.expanded ? 0 : (-me.infocontainer.nativeElement.offsetWidth);
    me.container.nativeElement.setAttribute('style', 'right: ' + rightPosition + "px");
    me.PushChanges();
  }

  /** Formated price */
  public priceFormatter(price: number): string {
    const me = this;
    return me._webShopService.formatCurrency(price);
  }

  /** Navigation to service selection */
  public navigateToGroupOrder() {
    const me = this;
    me._router.navigate(["/remoteOrderGroupServiceSelector"]);
  }

  public navigateToGroupSummary() {
    const me = this;
    me._router.navigate(["/remoteOrderGroupSummary"]);
  }
}


